import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import logo from '../assets/logo-dark.png'
import { useLocation, useNavigate } from 'react-router-dom'
import AppDownloadModal from '../components/AppDownloadModal'
import AdvertisementModal from '../components/AdvertisementModal'
import addsIcon from '../assets/images/icons/adds.png'
import brandIcon from '../assets/brand_logo.png'

import flagSK from '../assets/images/flag-sk.png'
import flagEN from '../assets/images/flag-uk.png'
import flagHU from '../assets/images/flag-hu.png'
import flagCZ from '../assets/images/flag-cz.png'
import flagPL from '../assets/images/flag-pl.png'
import flagDE from '../assets/images/flag-de.png'
import flagUA from '../assets/images/flag-ua.png'
import flagFR from '../assets/images/flag-fr.png'
import flagES from '../assets/images/flag-es.png'
import flagEE from '../assets/images/flag-ee.png'

import RegistrationModal from '../components/RegistrationModal'
import LoginModal from '../components/LoginModal'
import { primaryButtonStyle as originalPrimaryButtonStyle } from '../styles/buttonStyles'
import { useAuth } from '../context/AuthContext'
import { fetchWithAuth } from '../utils/fetchWithAuth'
import { showFloatingPromoBannerFromClickable } from '../utils/promoBannerEvents'

const primaryButtonStyle = (pressedBtn, key, hovered) => {
  const style = originalPrimaryButtonStyle(pressedBtn, key, hovered)

  if (window.innerWidth > 768 || key === 'admin') {
    return style
  }

  return {
    ...style,
    padding: '6px 10px',
    minHeight: 32,
    minWidth: 0,
    width: 'auto',
    height: 'auto'
  }
}

const LANGS = [
  { code: 'sk', label: 'SK', flag: flagSK },
  { code: 'en', label: 'EN', flag: flagEN },
  { code: 'hu', label: 'HU', flag: flagHU },
  { code: 'cs', label: 'CZ', flag: flagCZ },
  { code: 'pl', label: 'PL', flag: flagPL },
  { code: 'de', label: 'DE', flag: flagDE },
  { code: 'ua', label: 'UA', flag: flagUA },
  { code: 'fr', label: 'FR', flag: flagFR },
  { code: 'es', label: 'ES', flag: flagES },
  { code: 'et', label: 'ET', flag: flagEE },
]

const ENABLED_LANGS = ['sk', 'en', 'hu', 'cs', 'pl', 'de', 'ua', 'fr', 'es', 'et']

const Header = () => {
const [viewport, setViewport] = useState(window.innerWidth)
const isMobile = viewport <= 768 ||
  (viewport <= 950 && window.innerHeight <= 500 && window.innerWidth > window.innerHeight)
const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

useEffect(() => {
  const onResize = () => setViewport(window.innerWidth)
  window.addEventListener('resize', onResize)
  return () => window.removeEventListener('resize', onResize)
}, [])

let layout = {}

if (viewport <= 768) {
  layout = {
    headerHeight: 100,
    logoHeight: 70,
    iconSize: 20,
    langWidth: 56,
    langHeight: 34,
    fontSize: 35,
    paddingX: 12
  }
} else if (viewport >= 1920) {
  layout = {
    headerHeight: 100,
    logoHeight: 80,
    iconSize: 25,
    langWidth: 80,
    langHeight: 44,
    fontSize: 35,
    paddingX: 40
  }
} 
else if (viewport >= 1366) {
  layout = {
    headerHeight: 100,
    logoHeight: 70,
    iconSize: 25,
    langWidth: 80,
    langHeight: 44,
    fontSize: 35,
    paddingX: 40
  }
} 
else {
  layout = {
    headerHeight: 100,
    logoHeight: 70,
    iconSize: 25,
    langWidth: 80,
    langHeight: 44,
    fontSize: 35,
    paddingX: 40
  }
}
  const { i18n, t } = useTranslation()
  const { user, loading, logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

const goToHome = () => {
  if (!user) {
    navigate('/')
    return
  }

  if (location.pathname === '/home') {
    window.dispatchEvent(new Event('home-reset-center-view'))
    return
  }

  navigate('/home')
}

  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  const [hover, setHover] = useState(false)
  const [pressed, setPressed] = useState(false)
  const [hoverLang, setHoverLang] = useState(null)

  const [showRegModal, setShowRegModal] = useState(false)
  const [showLoginModal, setShowLoginModal] = useState(false)
  const [showDownloadModal, setShowDownloadModal] = useState(false)
const [showAdvertisementModal, setShowAdvertisementModal] = useState(false)
  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)
  const [adminMode, setAdminMode] = useState(() => sessionStorage.getItem('admin-home-mode') === 'true')

const [showDownloadHint, setShowDownloadHint] = useState(false)
const [downloadTooltipTimer, setDownloadTooltipTimer] = useState(null)
const [downloadCursorPos, setDownloadCursorPos] = useState({ x: 0, y: 0 })

const [showAddsHint, setShowAddsHint] = useState(false)
const [addsTooltipTimer, setAddsTooltipTimer] = useState(null)
const [addsCursorPos, setAddsCursorPos] = useState({ x: 0, y: 0 })
const [showRegisterHint, setShowRegisterHint] = useState(false)
const [registerTooltipTimer, setRegisterTooltipTimer] = useState(null)
const [registerCursorPos, setRegisterCursorPos] = useState({ x: 0, y: 0 })

  const lang = i18n.language?.split('-')[0] || 'sk'
  const active = LANGS.find(l => l.code === lang) || LANGS[0]

  const homeIcon = require('../assets/images/icons/home.png')
  const adminIcon = require('../assets/images/icons/admin.png')
  const adminOpenIcon = require('../assets/images/icons/admin_open.png')
  const downloadIcon = require('../assets/images/icons/app_download.png')

  const changeLanguage = async (code) => {
    if (!ENABLED_LANGS.includes(code)) {
      setOpen(false)
      return
    }
    i18n.changeLanguage(code)
    localStorage.setItem('lang', code)
    setOpen(false)

    if (!user) return

    try {
      await fetchWithAuth(
        '/auth/me',
        {
          method: 'PUT',
          body: JSON.stringify({ lang: code }),
          headers: { 'Accept-Language': code }
        },
        code
      )
    } catch (err) {
      console.error('Nepodarilo sa uložiť jazyk používateľa.', err)
    }
  }

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

useEffect(() => {
  setOpen(false)

  if (!user) {
    setAdminMode(false)
    sessionStorage.removeItem('admin-home-mode')
  }
}, [user])

  useEffect(() => {
    if (loading || user) return

    const params = new URLSearchParams(location.search)
    if (!['1', 'true', 'yes'].includes((params.get('showLogin') || '').toLowerCase())) return

    setShowLoginModal(true)
    params.delete('showLogin')

    navigate(
      {
        pathname: location.pathname,
        search: params.toString() ? `?${params.toString()}` : ''
      },
      { replace: true }
    )
  }, [loading, user, location.pathname, location.search, navigate])
useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setOpen(false)
      document.activeElement?.blur()
    }
  }

  window.addEventListener('keydown', handleKeyDown)
  return () => window.removeEventListener('keydown', handleKeyDown)
}, [])

  return (
<header
  className="enerqiq-header"
  onClickCapture={showFloatingPromoBannerFromClickable}
      style={{
        position: 'relative',
        zIndex: 1000,
	height: layout.headerHeight,
	padding: `0 ${layout.paddingX}px`,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#0A303B',
        overflow: 'visible'
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/pattern_6.png')",
          backgroundRepeat: 'repeat',
          backgroundSize: '400px 400px',
          opacity: 0.1,
          pointerEvents: 'none',
          zIndex: 0
        }}
      />

{isMobile && (
  <button
    type="button"
    className="enerqiq-mobile-menu-toggle"
    aria-label="Menu"
    aria-expanded={mobileMenuOpen}
    onClick={() => setMobileMenuOpen(prev => !prev)}
  >
    {mobileMenuOpen ? '✕' : '☰'}
  </button>
)}

<div
  data-promo-clickable="true"
  onClick={goToHome}
  className="enerqiq-header-slogan"
  style={{
    display: 'flex',
    alignItems: 'center',
    fontSize: layout.fontSize,
    fontWeight: 700,
    marginLeft: -20,
    position: 'relative',
    zIndex: 1,
    filter: 'drop-shadow(0 10px 8px rgba(0,0,0,0.4))',
    marginTop: layout.headerHeight * 0.3,
    cursor: 'pointer'
  }}
>
  <img
    src={brandIcon}
    alt="EnerqiQ"
    style={{
      height: layout.fontSize + 5,
      width: 'auto',
      marginRight: 8,
    }}
  />

  <span style={{ color: '#b3b0b5' }}>
    {t('SLOGAN')}{' '}
  </span>

  <span style={{ color: '#079086', marginLeft: 10 }}>
    iQ
  </span>

  {lang === 'hu' && (
    <span style={{ color: '#1e3f44' }}>
      {t('POST_SLOGAN_HU')}
    </span>
  )}
</div>

      <div
  	className="enerqiq-header-logo"
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1
        }}
      >
        <img
          src={logo}
          alt="Logo"
          data-promo-clickable="true"
          onClick={goToHome}
          style={{
            height: layout.logoHeight,
            width: 'auto',
            objectFit: 'contain',
            filter: 'drop-shadow(0 10px 8px rgba(0,0,0,0.4))',
            cursor: 'pointer'
          }}
        />
      </div>

      <div
        style={{
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          position: 'relative',
          zIndex: 1
        }}
      >
{!loading && !user && (
  <div
    className={`enerqiq-header-buttons ${mobileMenuOpen ? 'mobile-open' : ''}`}
    style={{ display: 'flex', gap: 12 }}
    onClickCapture={() => {
      if (isMobile) setMobileMenuOpen(false)
    }}
  >
<button
  style={{
    ...primaryButtonStyle(pressedBtn, 'download', hoverBtn === 'download'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}
  onMouseEnter={(e) => {
    setHoverBtn('download')

    const timer = setTimeout(() => {
      setShowDownloadHint(true)
    }, 600)

    setDownloadTooltipTimer(timer)
    setDownloadCursorPos({ x: e.clientX, y: e.clientY })
  }}
  onMouseMove={(e) => {
    setDownloadCursorPos({ x: e.clientX, y: e.clientY })
  }}
  onMouseLeave={() => {
    setHoverBtn(null)
    setPressedBtn(null)

    if (downloadTooltipTimer) clearTimeout(downloadTooltipTimer)

    setShowDownloadHint(false)
  }}
  onMouseDown={() => setPressedBtn('download')}
  onMouseUp={() => setPressedBtn(null)}
  onClick={() => setShowDownloadModal(true)}
>
  <img
    src={downloadIcon}
    alt="download"
    style={{
      width: layout.iconSize,
      height: layout.iconSize,
      objectFit: 'contain',
      filter: 'brightness(0) saturate(100%) invert(88%) sepia(5%) saturate(220%) hue-rotate(225deg) brightness(96%) contrast(92%)'
    }}
  />
</button>

<button
  style={{
    ...primaryButtonStyle(pressedBtn, 'adds', hoverBtn === 'adds'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}
  onMouseEnter={(e) => {
    setHoverBtn('adds')

    const timer = setTimeout(() => {
      setShowAddsHint(true)
    }, 600)

    setAddsTooltipTimer(timer)
    setAddsCursorPos({ x: e.clientX, y: e.clientY })
  }}
  onMouseMove={(e) => {
    setAddsCursorPos({ x: e.clientX, y: e.clientY })
  }}
  onMouseLeave={() => {
    setHoverBtn(null)
    setPressedBtn(null)

    if (addsTooltipTimer) clearTimeout(addsTooltipTimer)

    setShowAddsHint(false)
  }}
  onMouseDown={() => setPressedBtn('adds')}
  onMouseUp={() => setPressedBtn(null)}
  onClick={() => setShowAdvertisementModal(true)}
>
  <img
    src={addsIcon}
    alt="adds"
    style={{
      width: layout.iconSize,
      height: layout.iconSize,
      objectFit: 'contain',
      filter: 'brightness(0) saturate(100%) invert(88%) sepia(5%) saturate(220%) hue-rotate(225deg) brightness(96%) contrast(92%)'
    }}
  />
</button>

            <button
              style={primaryButtonStyle(pressedBtn, 'register', hoverBtn === 'register')}
		onMouseEnter={(e) => {
		  setHoverBtn('register')

		  const timer = setTimeout(() => {
		    setShowRegisterHint(true)
		  }, 600)

		  setRegisterTooltipTimer(timer)
		  setRegisterCursorPos({ x: e.clientX, y: e.clientY })
		}}
		onMouseMove={(e) => {
		  setRegisterCursorPos({ x: e.clientX, y: e.clientY })
		}}
		onMouseLeave={() => {
		  setHoverBtn(null)
		  setPressedBtn(null)

 		 if (registerTooltipTimer) clearTimeout(registerTooltipTimer)

 		 setShowRegisterHint(false)
		}}
              onMouseDown={() => setPressedBtn('register')}
              onMouseUp={() => setPressedBtn(null)}
              onClick={() => setShowRegModal(true)}
            >
              {t('REGISTER')}
            </button>

            <button
              style={primaryButtonStyle(pressedBtn, 'login', hoverBtn === 'login')}
              onMouseEnter={() => setHoverBtn('login')}
              onMouseLeave={() => {
                setHoverBtn(null)
                setPressedBtn(null)
              }}
              onMouseDown={() => setPressedBtn('login')}
              onMouseUp={() => setPressedBtn(null)}
              onClick={() => setShowLoginModal(true)}
            >
              {t('LOGIN')}
            </button>
          </div>
        )}

{!loading && user && (
  <div
    className={`enerqiq-header-buttons ${mobileMenuOpen ? 'mobile-open' : ''}`}
    style={{ display: 'flex', gap: 12 }}
    onClickCapture={() => {
      if (isMobile) setMobileMenuOpen(false)
    }}
  >
{user.role === 'admin' && location.pathname === '/home' && (
  <button
style={{
  ...primaryButtonStyle(pressedBtn, 'admin', hoverBtn === 'admin'),
  background: adminMode
    ? hoverBtn === 'admin'
      ? '#8f2635'
      : '#6f1d2c'
    : primaryButtonStyle(
        pressedBtn,
        'admin',
        hoverBtn === 'admin'
      ).background,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}}
    onMouseEnter={() => setHoverBtn('admin')}
    onMouseLeave={() => {
      setHoverBtn(null)
      setPressedBtn(null)
    }}
    onMouseDown={() => setPressedBtn('admin')}
    onMouseUp={() => setPressedBtn(null)}
onClick={() => {
  setAdminMode(current => {
    const nextAdminMode = !current

    sessionStorage.setItem('admin-home-mode', String(nextAdminMode))

    window.dispatchEvent(
      new CustomEvent('toggle-admin-home-buttons', {
        detail: nextAdminMode
      })
    )

    return nextAdminMode
  })
}}
  >
    <img
      src={adminMode ? adminOpenIcon : adminIcon}
      alt="admin"
style={{
  width: layout.iconSize,
  height: layout.iconSize,
  objectFit: 'contain',
  transform: adminMode ? 'translateY(1.5px) scale(1.15)' : 'none',
  transformOrigin: 'center',
  filter: 'brightness(0) saturate(100%) invert(88%) sepia(5%) saturate(220%) hue-rotate(225deg) brightness(96%) contrast(92%)'
}}
    />
  </button>
)}
<button
  style={{
    ...primaryButtonStyle(pressedBtn, 'download', hoverBtn === 'download'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}
  onMouseEnter={(e) => {
    setHoverBtn('download')

    const timer = setTimeout(() => {
      setShowDownloadHint(true)
    }, 600)

    setDownloadTooltipTimer(timer)
    setDownloadCursorPos({ x: e.clientX, y: e.clientY })
  }}
  onMouseMove={(e) => {
    setDownloadCursorPos({ x: e.clientX, y: e.clientY })
  }}
  onMouseLeave={() => {
    setHoverBtn(null)
    setPressedBtn(null)

    if (downloadTooltipTimer) clearTimeout(downloadTooltipTimer)

    setShowDownloadHint(false)
  }}
  onMouseDown={() => setPressedBtn('download')}
  onMouseUp={() => setPressedBtn(null)}
  onClick={() => setShowDownloadModal(true)}
>
  <img
    src={downloadIcon}
    alt="download"
    style={{
      width: layout.iconSize,
      height: layout.iconSize,
      objectFit: 'contain',
      filter: 'brightness(0) saturate(100%) invert(88%) sepia(5%) saturate(220%) hue-rotate(225deg) brightness(96%) contrast(92%)'
    }}
  />
</button>

<button
  style={{
    ...primaryButtonStyle(pressedBtn, 'adds', hoverBtn === 'adds'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}
  onMouseEnter={(e) => {
    setHoverBtn('adds')

    const timer = setTimeout(() => {
      setShowAddsHint(true)
    }, 600)

    setAddsTooltipTimer(timer)
    setAddsCursorPos({ x: e.clientX, y: e.clientY })
  }}
  onMouseMove={(e) => {
    setAddsCursorPos({ x: e.clientX, y: e.clientY })
  }}
  onMouseLeave={() => {
    setHoverBtn(null)
    setPressedBtn(null)

    if (addsTooltipTimer) clearTimeout(addsTooltipTimer)

    setShowAddsHint(false)
  }}
  onMouseDown={() => setPressedBtn('adds')}
  onMouseUp={() => setPressedBtn(null)}
  onClick={() => setShowAdvertisementModal(true)}
>
  <img
    src={addsIcon}
    alt="adds"
    style={{
      width: layout.iconSize,
      height: layout.iconSize,
      objectFit: 'contain',
      filter: 'brightness(0) saturate(100%) invert(88%) sepia(5%) saturate(220%) hue-rotate(225deg) brightness(96%) contrast(92%)'
    }}
  />
</button>

<button
  style={{
    ...primaryButtonStyle(pressedBtn, 'home', hoverBtn === 'home'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}
  onMouseEnter={() => setHoverBtn('home')}
  onMouseLeave={() => {
    setHoverBtn(null)
    setPressedBtn(null)
  }}
  onMouseDown={() => setPressedBtn('home')}
  onMouseUp={() => setPressedBtn(null)}
  onClick={goToHome}
>
  <img
    src={homeIcon}
    alt="home"
    style={{
	width: layout.iconSize,
	height: layout.iconSize,
      objectFit: 'contain',
      filter: 'brightness(0) saturate(100%) invert(88%) sepia(5%) saturate(220%) hue-rotate(225deg) brightness(96%) contrast(92%)'
    }}
  />
</button>

            <button
              style={primaryButtonStyle(pressedBtn, 'logout', hoverBtn === 'logout')}
              onMouseEnter={() => setHoverBtn('logout')}
              onMouseLeave={() => {
                setHoverBtn(null)
                setPressedBtn(null)
              }}
              onMouseDown={() => setPressedBtn('logout')}
              onMouseUp={() => setPressedBtn(null)}
              onClick={logout}
            >
              {t('LOGOUT')}
            </button>
          </div>
        )}

        <div
  ref={ref}
  className="enerqiq-header-language"
  style={{ position: 'relative' }}
>
          <button
            onClick={() => setOpen(!open)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => {
              setHover(false)
              setPressed(false)
            }}
            onMouseDown={() => setPressed(true)}
            onMouseUp={() => setPressed(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
		width: layout.langWidth,
		height: layout.langHeight,
              borderRadius: 20,
              cursor: 'pointer',
              background: hover
                ? 'rgba(0,0,0,0.80)'
                : 'rgba(0,0,0,0.6)',
              border: '1.5px solid #0A303B',
              boxShadow: pressed
                ? 'inset 0 4px 8px rgba(0,0,0,0.6)'
                : '0 6px 20px rgba(0,0,0,0.65)',
              transform: pressed ? 'scale(0.96)' : 'scale(1)',
              transition: 'transform 0.08s ease, box-shadow 0.08s ease',
              color: '#E7DFEC'
            }}
          >
            <img
              src={active.flag}
              alt={active.label}
              style={{ width: layout.iconSize * 1.2, height: layout.iconSize * 0.85, marginRight: 6 }}
            />
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>
              {active.label}
            </span>
          </button>

          {open && (
            <>
              <div
                onClick={() => setOpen(false)}
                style={{
                  position: 'fixed',
                  inset: 0,
                  background: 'transparent',
                  zIndex: 999
                }}
              />

              <div
                style={{
                  position: 'absolute',
                  top: 46,
                  right: 0,
                  background: 'rgba(0,0,0,0.75)',
                  borderRadius: 10,
                  padding: 10,
                  display: 'flex',
                  flexWrap: 'wrap',
                  width: 280,
                  zIndex: 1000,
                  border: '1.5px solid #0A303B',
                  boxShadow: '0 12px 28px rgba(0,0,0,0.65)'
                }}
              >
                {LANGS.map(item => {
                  const isActive = item.code === lang

                  return (
                    <div
                      key={item.code}
                      onClick={() => changeLanguage(item.code)}
                      onMouseEnter={() => setHoverLang(item.code)}
                      onMouseLeave={() => setHoverLang(null)}
style={{
  width: '33.33%',
  marginLeft:
    item.code === 'et' && LANGS.length % 3 === 1
      ? '33.33%'
      : 0,
  textAlign: 'center',
  cursor: 'pointer',
  padding: '8px 0',
  borderRadius: 8,
  background:
    hoverLang === item.code
      ? 'rgba(255,255,255,0.08)'
      : 'transparent',
  transform:
    hoverLang === item.code
      ? 'scale(1.05)'
      : 'scale(1)',
  transition: 'all 0.12s ease'
}}
                    >
                      <div
                        style={{
                          width: 68,
                          height: 44,
                          margin: '0 auto',
                          position: 'relative'
                        }}
                      >
                        <img
                          src={item.flag}
                          alt={item.label}
                          style={{ width: '100%', height: '100%' }}
                        />

                        {isActive && (
                          <div
                            style={{
                              position: 'absolute',
                              inset: -1,
                              border: '1px solid #e7dfec'
                            }}
                          />
                        )}
                      </div>

                      <div
                        style={{
                          color: '#e7dfec',
                          fontWeight: 'bold',
                          fontSize: 13
                        }}
                      >
                        {item.label}
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          )}
        </div>
      </div>
{showDownloadHint && (
  <div
    style={{
      position: 'fixed',
      top: downloadCursorPos.y - 50,
      left: downloadCursorPos.x,
      transform: 'translateX(-50%)',
      background: 'rgba(0,0,0,0.85)',
      color: '#e7dfec',
      padding: '6px 14px 8px 14px',
      borderRadius: 12,
      fontSize: 16,
      whiteSpace: 'nowrap',
      pointerEvents: 'none',
      zIndex: 5000,
      border: '1.5px solid #0A303B',
      boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1
    }}
  >
    {t('DOWNLOAD_APP')}
  </div>
)}

{showAddsHint && (
  <div
    style={{
      position: 'fixed',
      top: addsCursorPos.y - 50,
      left: addsCursorPos.x,
      transform: 'translateX(-50%)',
      background: 'rgba(0,0,0,0.85)',
      color: '#e7dfec',
      padding: '6px 14px 8px 14px',
      borderRadius: 12,
      fontSize: 16,
      whiteSpace: 'nowrap',
      pointerEvents: 'none',
      zIndex: 5000,
      border: '1.5px solid #0A303B',
      boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1
    }}
  >
    {t('ADS_BUTTON')}
  </div>
)}

{showRegisterHint && (
  <div
    style={{
      position: 'fixed',
      top: registerCursorPos.y - 50,
      left: registerCursorPos.x,
      transform: 'translateX(-50%)',
      background: 'rgba(0,0,0,0.85)',
      color: '#e7dfec',
      padding: '6px 14px 8px 14px',
      borderRadius: 12,
      fontSize: 16,
      whiteSpace: 'nowrap',
      pointerEvents: 'none',
      zIndex: 5000,
      border: '1.5px solid #0A303B',
      boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1
    }}
  >
    {t('REGISTER_NOW')}
  </div>
)}

      <RegistrationModal
        open={showRegModal}
        onClose={() => {
          setShowRegModal(false)
          document.activeElement?.blur()
        }}
      />
<AppDownloadModal
  open={showDownloadModal}
  onClose={() => {
    setShowDownloadModal(false)
    document.activeElement?.blur()
  }}
/>

<AdvertisementModal
  open={showAdvertisementModal}
  onClose={() => {
    setShowAdvertisementModal(false)
    document.activeElement?.blur()
  }}
/>
      {showLoginModal && (
        <LoginModal
          open={true}
          onClose={() => {
            setShowLoginModal(false)
            document.activeElement?.blur()
          }}
        />
      )}
    </header>
  )
}

export default Header